// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scale-list-plugin[data-v-6028a002]{pointer-events:auto;margin-right:5px;margin-left:5px;margin-bottom:2px}@container (max-width: 600px ){.scale-list-plugin{display:none}}", ""]);
// Exports
module.exports = exports;
